(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/barcode/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/barcode/index.js');
"use strict";

const payFooterTexts = {
  PRINT: 'SKRIV UT PRESENTKOD',
  REDEEM_ONLINE: 'LÖS IN ONLINE',
  SCRATCH_NEXT_VOUCHER: 'SKRAPA NÄSTA PRESENTLOTT'
};
const Barcode = _ref => {
  let {
    giftCode,
    manual,
    history,
    numberOfTickets,
    totalPrice,
    availableOnline,
    nextVoucher
  } = _ref;
  const {
    PRINT,
    REDEEM_ONLINE,
    SCRATCH_NEXT_VOUCHER
  } = payFooterTexts;
  const BarcodePrint = svs.ticket_gifts.barcode.components.BarcodePrint;
  const ManualInfo = svs.ticket_gifts.barcode.components.ManualInfo;
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const {
    reactPayfooterCustomerServiceTexts
  } = svs.ticket_gifts.constants;
  window.scroll(0, 0);
  const handleRedeemOnlineClick = e => {
    e && e.preventDefault();
    history && history.push("/".concat(giftCode).concat(history.location.search));
  };
  const handlePrintClick = e => {
    e && e.preventDefault();
    window.print();
  };
  const handleGoToNext = e => {
    e === null || e === void 0 || e.preventDefault();
    history.push("../../".concat(giftCode));
    history.push("".concat(giftCode, "/spela/").concat(nextVoucher.voucherId));
  };
  const getPayFooterButtons = (nextVoucher, availableOnline) => {
    const payfooterButtons = [];
    if (availableOnline) {
      payfooterButtons.push({
        primary: true,
        text: REDEEM_ONLINE,
        onClick: handleRedeemOnlineClick
      });
    } else if (nextVoucher) {
      payfooterButtons.push({
        primary: true,
        text: SCRATCH_NEXT_VOUCHER,
        onClick: handleGoToNext
      });
    }
    payfooterButtons.push({
      secondary: true,
      text: PRINT,
      onClick: handlePrintClick
    });
    return payfooterButtons;
  };
  React.useEffect(() => {
    JsBarcode('#js-voucher-barcode', "VV".concat(giftCode), {
      format: 'code128',
      width: 2,
      displayValue: false
    });
  }, [giftCode]);
  let header = '';
  const infoTop = 'Scanna streckkoden under kundskärmen i din spelbutik med mobilen.';
  const infoMid = 'Du kan även uppge koden för kassapersonalen.';
  const infoBot = 'Koden är en värdehandling tills dina lotter är uthämtade.';
  switch (true) {
    case numberOfTickets > 1:
      header = "".concat(numberOfTickets ? "".concat(numberOfTickets, " p") : 'P', "resentlotter").concat(totalPrice ? " till ett v\xE4rde av ".concat(totalPrice, "\xA0kr") : '');
      break;
    case !numberOfTickets:
      header = 'Kod för present';
      break;
    case Number(numberOfTickets) === 1:
      header = "En presentlott".concat(totalPrice ? " till ett v\xE4rde av ".concat(totalPrice, "\xA0kr") : '');
      break;
    default:
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "barcode-print-wrapper"
  }, React.createElement(BarcodePrint, {
    giftCode: giftCode,
    manual: manual,
    numberOfTickets: numberOfTickets,
    totalPrice: totalPrice
  })), React.createElement("div", {
    className: "f-center padding-bottom-1"
  }, React.createElement("h1", {
    className: "barcode-header f-800 padding-top-2 padding-left-1 padding-right-1 margin-1"
  }, header), React.createElement("div", {
    className: "padding-1 margin-left-1 margin-right-1 f-400 f-normal"
  }, infoTop), React.createElement("div", {
    className: "padding-1 margin-left-1 margin-right-1 f-400 f-normal"
  }, infoMid), React.createElement("div", {
    className: "padding-1 margin-left-1 margin-right-1 f-400 f-bold"
  }, infoBot), React.createElement("div", {
    className: manual ? 'f-800 padding-top-2' : 'f-800 padding-2 margin-bottom-1'
  }, giftCode && giftCode.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), manual && React.createElement(ManualInfo, null), React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("img", {
    id: "js-voucher-barcode"
  }))), React.createElement(Payfooter, {
    buttons: getPayFooterButtons(nextVoucher, availableOnline),
    isBottom: true,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.barcode.components.payFooterTexts', payFooterTexts);
setGlobal('svs.ticket_gifts.barcode.components.Barcode', Barcode);

 })(window);